export default "<div id=\"mapId\" style=\"width: 100%; height: 180px;\"></div>\n";